import './style'
import App from './components/app'
import { render } from 'preact'
import { Route, Router } from 'preact-router'
import { lazy } from 'preact/compat'
import { lazyWithRetry } from './lib/utils'

const TermsPage = lazy(() => 
  lazyWithRetry(() => import('./pages/Terms'))
)
const CreditsPage = lazy(() => 
  lazyWithRetry(() => import('./pages/Credits'))
)

render(
  <Router>
    <Route path="/" component={App} />
    <Route path="/terms" component={TermsPage} />
    <Route path="/credits" component={CreditsPage} />
  </Router>,
  document.body
)
